import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';

import { type PageFooterVariant, StyledPageFooter } from './Footer.styles';

export type { PageFooterVariant };

export type PageFooterProps = ComponentPropsWithoutRef<'footer'> & {
	children?: ReactNode;
	variant?: PageFooterVariant;
};

const Footer: FC<PageFooterProps> = ({ children, variant = 'default', tw, ...props }) => (
	<StyledPageFooter $variant={variant} tw={tw} {...props}>
		{children}
	</StyledPageFooter>
);

export default Footer;
